import { ObserveView } from '@/components/ObserveView';
import { initSocket } from '@/socket';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import z from 'zod';

export const Route = createFileRoute('/observe-game')({
	component: RouteComponent,
	validateSearch: z.object({
		locationId: z.uuid(),
	}),
});

function RouteComponent() {
	const { locationId } = Route.useSearch();

	useEffect(() => {
		console.log('initializing socket for observed game: ', locationId);
		initSocket(locationId);
	}, [locationId]);

	return <ObserveView />;
}
